import { render, staticRenderFns } from "./SyncOff.vue?vue&type=template&id=54ff24b6&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SyncOff.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/SyncOff.vue
// module id = 2438
// module chunks = 1